const sendToGA4 = ({ name, value }) => {
  if (window.gtag) {
    window.gtag('event', name, {
      event_category: 'Web Vitals',
      event_label: window.location.pathname,
      value: Math.round(value),
    });
  }
};


const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);

         getCLS(sendToGA4);
      getFID(sendToGA4);
      getLCP(sendToGA4);
      getFCP(sendToGA4);
      getTTFB(sendToGA4);
    });
  }
};

export default reportWebVitals;



